<template>
  <div class="prompt">
    <div class="prompt-card">
      <img src="@/assets/warning.png" height="125" width="125">
      <p>This is a medium to high-risk investment. We will execute a contract/ agreement
      with our partners to safeguard SIC Investments with them. Nonetheless, as with any
      investment, are you aware of the unlikely loss of your investment, delay in repayment,
      and other possible risks?</p>
      <div class="button-group">
        <button class="btn-success btn" @click="accept">Accept</button>
        <button class="btn-error btn" @click="decline">Decline</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    accept() {
      this.$emit('accept');
    },
    decline() {
      this.$emit('decline');
    },
  },
};
</script>

<style scoped>
  p{
    margin-top: 1rem;
    font-weight: 400;
  }
  .button-group{
    display: flex;
    justify-content: space-around;
  }
  .btn-error{
    background-color: #F44777;
    color: #FFF;
  }
</style>
